module.exports = __webpack_public_path__ + "static/xx-7c665d59fa100f9fb98e2af6367ca0fd.png";